export { default } from './formatMuiErrorMessage';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/formatMuiErrorMessage/index.js
// module id = 48
// module chunks = 22